import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toggleEventPanelAction } from '@/domain/events';
import { matchRoute } from '@/domain/router/utils';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@/components/mui/Tooltip';

import HistoryIcon from '@mui/icons-material/History';

import elements from '@/components/elements';

const EventsHistoryIconButton = () => {
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const isCompanyWorkspace = matchRoute.isCompanyWorkspace();
  const isDocument = matchRoute.isDocument();
  const isCompanyBankFeed = matchRoute.isCompanyBankFeed();
  const isPaymentWorkspace = matchRoute.isPaymentWorkspace();
  const isPayment = matchRoute.isPayment();
  const isVisibleIcon =
    companyId && (isCompanyWorkspace || isDocument || isCompanyBankFeed || isPaymentWorkspace || isPayment);

  const onClick = () => {
    dispatch(toggleEventPanelAction());
  };

  return (
    isVisibleIcon && (
      <Tooltip t={{ id: 'header.menu.history', defaultMessage: 'History' }}>
        <IconButton color="primary" onClick={onClick} data-element={elements.history.openHistoryButton}>
          <HistoryIcon />
        </IconButton>
      </Tooltip>
    )
  );
};

export default EventsHistoryIconButton;
